import { render, staticRenderFns } from "./LoyaltyPuntosColombia.vue?vue&type=template&id=60918ec9"
import script from "./LoyaltyPuntosColombia.vue?vue&type=script&lang=js"
export * from "./LoyaltyPuntosColombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports